import styled from "styled-components";
import { BONUS_IMG, RefreshOutlined, IMG_Wallet_BG } from "@assets";
import { REJECTED_SK, REQUESTED_SK } from "@constants";

export const RootContainer = styled.div`
  position: relative;
  height: 100vh;
  overflow: hidden;
`;

export const RefreshIcon = styled(RefreshOutlined)`
  font-size: 24px;
  color: #fff;
`;

export const EmptyText = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #808080;
`;

export const ListContainer = styled.div`
  height: calc(100vh - 310px);
  overflow-y: auto;
  border-radius: 15px 15px 0px 0px;

  .loader {
    height: calc(100vh - 406px);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .empty-box {
    height: calc(100vh - 406px);
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: center;
    justify-content: center;

    svg {
      font-size: 24px;
      color: #808080;
    }
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const ListItem = styled.div`
  padding: 16px;
  margin-bottom: 1px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  gap: 12px;
  @media screen and (max-width: 350px) {
    padding: 6px;
    grid: 6px;
  }
  border-top: 1px solid #f2f1f0;
`;

export const DataWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: 5px;
`;

export const ItemImage = styled.img.attrs({
  alt: "img",
})`
  width: 55px;
  height: 55px;
  border-radius: 8px;
  object-fit: cover;

  @media screen and (max-width: 350px) {
    width: 38px;
    height: 38px;
  }
`;

export const InfoWrapper = styled.div`
  flex: 1;
  display: flex;
  width: 100%;

  > :nth-child(1) {
    flex: 1;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* grid-gap: 8px; */
`;

export const ItemText = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5;
  text-transform: capitalize;
  color: #0095DA;

  @media screen and (max-width: 400px) {
    font-size: 13px;
  }

  @media screen and (max-width: 300px) {
    font-size: 12px;
  }
`;

export const DateText = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5;
  color: #6D7F8A;

  @media screen and (max-width: 300px) {
    font-size: 11px;
  }
`;

export const AmountText = styled.div`
  white-space: nowrap;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  color: #0095DA;

  @media screen and (max-width: 400px) {
    font-size: 13px;
  }

  @media screen and (max-width: 300px) {
    font-size: 12px;
  }
`;

export const StatusText = styled.div`
  height: 100%;
  white-space: nowrap;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.5;
  text-transform: capitalize;
  color: ${(props) =>
    props.status === REQUESTED_SK
      ? "#000"
      : props.status === REJECTED_SK
      ? "#FFF"
      : "#FFF"};
  background-color: ${(props) =>
    props.status === REQUESTED_SK
      ? "#FFD15B"
      : props.status === REJECTED_SK
      ? "#BA0101"
      : "#33A600"};
  padding: 4px 12px 4px 12px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 300px) {
    font-size: 11px;
  }
`;

export const BonusStatusText = styled(StatusText)`
  text-transform: none;
  width: auto;
  color: ${(props) => (props.status === "Used" ? "#FFF" : "#FFF")};
  background-color: ${(props) =>
    props.status === "Used" ? "#BA0101" : "#33A600"};
  padding: 4px 12px 4px 12px;
  border-radius: 15px;
`;

export const LogoImage = styled.img.attrs({
  alt: "img",
  src: BONUS_IMG,
})`
  width: 50px;
  border-radius: 12px;
  object-fit: contain;
  align-self: center;
`;

export const Image = styled.img.attrs({
  alt: "img",
})`
  width: 50px;
  border-radius: 12px;
  object-fit: contain;
  align-self: center;
`;

export const ExpiredLabel = styled.span`
  white-space: nowrap;
  color: #e81530;
  font-size: 12px;
  font-style: normal;
  font-weight: 200;
  line-height: 1.5;

  @media screen and (max-width: 365px) {
    font-size: 11px;
  }
`;

export const ExpiredText = styled(ExpiredLabel)`
  color: #6D7F8A;
`;

export const TitleWrapper = styled.div`
  display: flex;
  margin: 0px 16px 8px 16px;
`;

export const Title = styled.div`
  flex: 1;
  font-size: 14px;
  font-weight: 400;
  color: #6D7F8A;
`;

export const LinkText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #0095DA;
  cursor: pointer;
`;

export const BalanceWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 16px;
  background: #fff;
  margin: 16px;
  margin-bottom: 0px;
`;

export const BalanceTitle = styled.div`
  background-image: url(${IMG_Wallet_BG});
  background-size: contain;
  background-repeat: no-repeat;
  width: 180px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #482701;
  font-weight: 600;
  font-size: 12px;
  position: relative;
  top: -85px;
`;

export const BalanceAmount = styled.div`
  color: #FFFFFF;
  font-size: 20px;
  font-weight: 500;
  margin-top: 8px;
  background: #0095DA;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
  padding-bottom: 20px;
  border-radius: 26px 26px 0px 0px;
  position: relative;
`;

export const SubBalanceWrapper = styled.div`
  background: #f2f1f0;
  border-radius: 0px 0px 26px 26px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  margin: 0px 16px;
  padding: 8px 0px;
  position: relative;
  top: -40px;
  background: #E1F0FF;
`;

export const SubBalanceTextWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 0.4;
`;

export const SubBalanceText = styled.div`
  font-size: 10px;
  font-weight: 400;
  color: #EDAD0C;

  @media screen and (max-width: 345px) {
    font-size: 9px;
  }
`;

export const Divider = styled.div`
  height: 35px;
  width: 1px;
  border-left: 1px solid #000;
`;

export const SubBalanceTitle = styled(SubBalanceText)`
  color: #000000;
  font-size: 12px;

  @media screen and (max-width: 345px) {
    font-size: 11px;
  }
`;

export const BalanceButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  width: 100%;
  position: relative;
  top: -20px;
`;

export const BalanceButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 44px;
  border-radius: 26px;
  background: #0095DA;
  color: #FFF;
  font-size: 12px;
  font-weight: 600;

  svg {
    padding-left: 5px;
  }

  @media screen and (max-width: 385px) {
    width: 100%;
    font-size: 12px;
  }
`;